import { render, staticRenderFns } from "./PageLoadingSpinner.vue?vue&type=template&id=83f5dbd0&scoped=true&"
import script from "./PageLoadingSpinner.vue?vue&type=script&lang=ts&"
export * from "./PageLoadingSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./PageLoadingSpinner.vue?vue&type=style&index=0&id=83f5dbd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f5dbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f5dbd0')) {
      api.createRecord('83f5dbd0', component.options)
    } else {
      api.reload('83f5dbd0', component.options)
    }
    module.hot.accept("./PageLoadingSpinner.vue?vue&type=template&id=83f5dbd0&scoped=true&", function () {
      api.rerender('83f5dbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/custom/PageLoadingSpinner.vue"
export default component.exports